import React, { useState, useEffect, useRef, useCallback } from "react";
import { Avatar } from "@material-ui/core";
// import { Route } from "react-router-dom";

// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUser, profileUpdate } from "../../actions/auth";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../components/ui/AppReactSelect";
// import { createUser } from "actions/auth";

// import Sidebar from "components/Sidebar/Sidebar";
// import AdminNavbar from "components/Navbars/AdminNavbar";
// import AdminFooter from "components/Footers/AdminFooter";
// import Auth from "../../views/Pages/Auth";
import moment from "moment";
import { getUserFromLocalStorage } from "utilities/user";
import {
  apiRbacReplacePermissionOverrides,
  apiStaff2FASetup,
  apiStaff2FAConfirm,
  apiStaff2FADisable,
  apiClearPlatformRole,
  apiConvertAccountType,
} from "../../api/index.js";
import StaffFeatureAccessEditor from "../../components/StaffFeatureAccessEditor";

const STAFF_2FA_ROLES = ['SUPERUSER', 'ADMIN', 'SUPERVISOR'];

// ── Design Tokens ──────────────────────────────────────────────────────
const COLORS = {
  bgPage:        '#f5f7fa',
  cardBg:        '#ffffff',
  cardBorder:    '#e2e8f0',
  cardShadow:    '0 4px 20px rgba(0,0,0,0.07)',
  accent:        '#033f70',   // Navy brand blue
  accentHover:   '#0867b5',
  accentLight:   'rgba(3,63,112,0.08)',
  success:       '#10b981',
  successLight:  'rgba(16,185,129,0.10)',
  danger:        '#ef4444',
  dangerLight:   'rgba(239,68,68,0.08)',
  textPrimary:   '#1e293b',
  textSecondary: '#64748b',
  textMuted:     '#94a3b8',
  border:        '#e2e8f0',
  inputBg:       '#f8fafc',
  inputBorder:   '#e2e8f0',
  inputFocus:    '#234268',
  avatarBg:      '#033f70',
  profileBanner: '#033f70',
};

const RADIUS = { card: 16, input: 10, button: 10, avatar: '50%' };
const TRANSITION = 'all 0.25s cubic-bezier(.4,0,.2,1)';

// ── Scoped Styles (injected once) ──────────────────────────────────────
const STYLE_TAG_ID = 'user-edit-adorned';
const injectStyles = () => {
  if (document.getElementById(STYLE_TAG_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_TAG_ID;
  style.textContent = `
    /* ── Avatar ring ─────────────────────────────── */
    .ue-avatar-ring {
      position: absolute; inset: -3px;
      border-radius: 50%;
      border: 3px solid ${COLORS.accent};
      background: transparent;
    }

    /* ── Fade-in for cards ────────────────────────── */
    @keyframes ue-fade-up {
      from { opacity: 0; transform: translateY(18px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .ue-card-animated {
      animation: ue-fade-up 0.5s ease-out both;
    }
    .ue-card-animated:nth-child(2) { animation-delay: 0.12s; }
    .ue-card-animated:nth-child(3) { animation-delay: 0.22s; }

    /* ── Input focus glow ────────────────────────── */
    .ue-input:focus {
      border-color: ${COLORS.inputFocus} !important;
      box-shadow: 0 0 0 3px rgba(3,63,112,0.13) !important;
      outline: none !important;
    }
    .ue-input {
      transition: ${TRANSITION} !important;
      background: ${COLORS.inputBg} !important;
      border: 1.5px solid ${COLORS.inputBorder} !important;
      border-radius: ${RADIUS.input}px !important;
      padding: 10px 14px !important;
      font-size: 14px !important;
      color: ${COLORS.textPrimary} !important;
    }
    .ue-input::placeholder { color: ${COLORS.textMuted} !important; }
    .ue-input:disabled {
      background: ${COLORS.accentLight} !important;
      color: ${COLORS.textSecondary} !important;
      cursor: not-allowed;
    }

    /* ── Section labels ──────────────────────────── */
    .ue-label {
      font-size: 11px !important;
      font-weight: 600 !important;
      letter-spacing: 0.6px !important;
      text-transform: uppercase !important;
      color: ${COLORS.textSecondary} !important;
      margin-bottom: 6px !important;
    }

    /* ── Primary button ──────────────────────────── */
    .ue-btn-primary {
      background: ${COLORS.accent} !important;
      border: none !important;
      border-radius: ${RADIUS.button}px !important;
      padding: 10px 28px !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      letter-spacing: 0.4px !important;
      color: #fff !important;
      transition: ${TRANSITION} !important;
      box-shadow: 0 4px 14px rgba(3,63,112,0.25) !important;
    }
    .ue-btn-primary:hover:not(:disabled) {
      background: ${COLORS.accentHover} !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 6px 20px rgba(3,63,112,0.35) !important;
    }
    .ue-btn-primary:disabled {
      opacity: 0.5 !important;
      cursor: not-allowed !important;
    }

    /* ── Secondary button (outline) ──────────────── */
    .ue-btn-secondary {
      background: #ffffff !important;
      border: 1.5px solid ${COLORS.accent} !important;
      border-radius: ${RADIUS.button}px !important;
      padding: 10px 28px !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      letter-spacing: 0.4px !important;
      color: ${COLORS.accent} !important;
      transition: ${TRANSITION} !important;
      box-shadow: none !important;
    }
    .ue-btn-secondary:hover:not(:disabled) {
      background: ${COLORS.accentLight} !important;
      transform: translateY(-1px) !important;
    }
    .ue-btn-secondary:disabled {
      opacity: 0.5 !important;
      cursor: not-allowed !important;
    }

    /* ── Role badge ──────────────────────────────── */
    .ue-role-badge {
      display: inline-block;
      padding: 3px 12px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    /* ── Select overrides ────────────────────────── */
    .ue-select .react-select__control {
      border: 1.5px solid ${COLORS.inputBorder} !important;
      border-radius: ${RADIUS.input}px !important;
      background: ${COLORS.inputBg} !important;
      min-height: 42px !important;
      box-shadow: none !important;
      transition: ${TRANSITION} !important;
    }
    .ue-select .react-select__control--is-focused {
      border-color: ${COLORS.inputFocus} !important;
      box-shadow: 0 0 0 3px rgba(3,63,112,0.13) !important;
    }
    .ue-select .react-select__single-value {
      font-size: 14px !important;
      color: ${COLORS.textPrimary} !important;
    }
    .ue-select .react-select__menu {
      border-radius: ${RADIUS.input}px !important;
      box-shadow: 0 10px 40px rgba(0,0,0,0.10) !important;
      z-index: 10 !important;
    }
    .ue-select .react-select__option--is-selected {
      background: ${COLORS.accent} !important;
    }
    .ue-select .react-select__option--is-focused:not(.react-select__option--is-selected) {
      background: ${COLORS.accentLight} !important;
    }

    /* ── Profile card refinements ────────────────── */
    .ue-profile-card .card-image img {
      filter: brightness(0.85);
      transition: filter 0.4s ease;
    }
    .ue-profile-card:hover .card-image img {
      filter: brightness(0.95);
    }

    /* ── 2FA card ────────────────────────────────── */
    .ue-2fa-chip {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 3px 10px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: 700;
    }

    /* ── Section divider ─────────────────────────── */
    .ue-divider {
      height: 1px;
      background: ${COLORS.border};
      margin: 20px 0;
      border: none;
    }

    /* ── Backup code grid ────────────────────────── */
    .ue-backup-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
      gap: 8px;
    }
    .ue-backup-code {
      background: ${COLORS.accentLight};
      border: 1px dashed ${COLORS.accent};
      border-radius: 8px;
      padding: 6px 10px;
      text-align: center;
      font-family: 'SFMono-Regular', monospace;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 2px;
      color: ${COLORS.accent};
    }
  `;
  document.head.appendChild(style);
};

const getRoleBadgeStyle = (role) => {
  const map = {
    SUPERUSER: { bg: '#fef3c7', color: '#92400e' },
    ADMIN: { bg: '#dbeafe', color: '#1e40af' },
    SUPERVISOR: { bg: '#ede9fe', color: '#212bb6' },
    CREATOR: { bg: '#d1fae5', color: '#065f46' },
    VENDOR: { bg: '#fce7f3', color: '#9d174d' },
  };
  const m = map[role] || { bg: '#f1f5f9', color: '#475569' };
  return { background: m.bg, color: m.color };
};

const cardStyle = {
  background: COLORS.cardBg,
  border: `1px solid ${COLORS.cardBorder}`,
  borderRadius: RADIUS.card,
  boxShadow: COLORS.cardShadow,
  overflow: 'hidden',
};

const sectionHeadStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  paddingBottom: 4,
  marginBottom: 0,
};

const sectionIconStyle = {
  width: 36,
  height: 36,
  borderRadius: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 16,
  flexShrink: 0,
};

const UserEdit = ({ match }) => {
  const user = getUserFromLocalStorage();
  const location = useLocation();

  const userId = match.params.userId;
  const auth = useSelector((state) => state.auth);
  const { agent, isLoading } = auth;

  // ── 2FA management state ────────────────────────────────────────────────
  const [twoFAStep, setTwoFAStep] = useState('idle'); // idle | setup | confirm | disable
  const [twoFALoading, setTwoFALoading] = useState(false);
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [twoFASecret, setTwoFASecret] = useState('');
  const [twoFATotpInput, setTwoFATotpInput] = useState('');
  const [twoFAError, setTwoFAError] = useState('');
  const [backupCodes, setBackupCodes] = useState([]);
  const [twoFAEnabled, setTwoFAEnabled] = useState(false);

  const isSelfEdit = user?.result?._id === userId;

  useEffect(() => {
    injectStyles();
  }, []);

  useEffect(() => {
    if (agent?.twoFA?.enabled !== undefined) setTwoFAEnabled(agent.twoFA.enabled);
  }, [agent]);

  useEffect(() => {
    if (location.hash !== '#two-factor-authentication' || !agent?._id) return;
    const t = requestAnimationFrame(() => {
      document.getElementById('two-factor-authentication')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return () => cancelAnimationFrame(t);
  }, [location.hash, agent?._id]);

  const handle2FASetup = async () => {
    setTwoFAError('');
    setTwoFALoading(true);
    try {
      const res = await apiStaff2FASetup();
      setQrDataUrl(res.data.data.qrDataUrl);
      setTwoFASecret(res.data.data.secret);
      setTwoFAStep('setup');
    } catch (err) {
      setTwoFAError(err.response?.data?.message || '2FA setup failed.');
    } finally {
      setTwoFALoading(false);
    }
  };

  const handle2FAConfirm = async () => {
    if (!twoFATotpInput.trim()) { setTwoFAError('Enter the 6-digit code.'); return; }
    setTwoFAError('');
    setTwoFALoading(true);
    try {
      const res = await apiStaff2FAConfirm(twoFATotpInput.trim());
      setBackupCodes(res.data.data.backupCodes);
      setTwoFAEnabled(true);
      setTwoFAStep('done');
      toast.success('2FA enabled successfully!');
    } catch (err) {
      setTwoFAError(err.response?.data?.message || 'Invalid code.');
    } finally {
      setTwoFALoading(false);
    }
  };

  const handle2FADisable = async () => {
    if (!twoFATotpInput.trim()) { setTwoFAError('Enter your current 6-digit code to confirm.'); return; }
    setTwoFAError('');
    setTwoFALoading(true);
    try {
      await apiStaff2FADisable(twoFATotpInput.trim());
      setTwoFAEnabled(false);
      setTwoFAStep('idle');
      setTwoFATotpInput('');
      toast.success('2FA has been disabled.');
    } catch (err) {
      setTwoFAError(err.response?.data?.message || 'Invalid code.');
    } finally {
      setTwoFALoading(false);
    }
  };

  const [postData, setPostData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    user_role: agent?.user_role || "",
  });
  const [permissionOverrides, setPermissionOverrides] = useState([]);
  const [accessReady, setAccessReady] = useState(false);
  const [saving, setSaving] = useState(false);
  // Super-admin account-management actions (clear a stray role, convert type).
  const [acting, setActing] = useState(false);
  const [convertOpen, setConvertOpen] = useState(false);
  const [convertType, setConvertType] = useState("");   // "LUSUKU STAFF" | "CLIENT"
  const [convertRole, setConvertRole] = useState("CONSUMER");
  const [confirmName, setConfirmName] = useState("");

  // ── WHAT KIND OF ACCOUNT IS THIS? ───────────────────────────────────────────
  // `userType` and `user_role` are orthogonal: every vendor owner row carries a
  // `user_role` too. This screen used to read only the role, so it happily
  // showed a vendor as "SUPERUSER", offered to assign it a platform role, and
  // saved that role for real — creating an account with platform authority that
  // appears in no staff list. The account type is already on the object the
  // page holds; it was simply never read.
  const STAFF_USER_TYPE = "LUSUKU STAFF";
  const accountLoaded = agent?._id === userId;
  const isStaffAccount = agent?.userType === STAFF_USER_TYPE;
  const accountKind =
    agent?.userType === "SELLER"
      ? "vendor account"
      : agent?.userType === "CLIENT"
        ? "customer account"
        : "non-staff account";
  // Staff-only controls are hidden until we know what we are editing, so the
  // role picker never flashes up for a vendor while the fetch is in flight.
  const staffControlsEnabled = accountLoaded && isStaffAccount;
  const canCustomizeAccess =
    user?.result?.user_role === "SUPERUSER" && staffControlsEnabled;
  const handleAccessChange = useCallback(
    (overrides) => setPermissionOverrides(overrides),
    []
  );

  // ── Super-admin visibility + control ────────────────────────────────────────
  // The acting admin is a super user (or carries the isSuperAdmin flag). Only
  // then are the account-type controls shown; the server enforces the same.
  const actingSuperUser =
    user?.result?.user_role === "SUPERUSER" || user?.result?.isSuperAdmin === true;
  // The storefront(s) this login owns, sent alongside the account by findUser.
  const linkedVendorProfiles = Array.isArray(agent?.linkedVendorProfiles)
    ? agent.linkedVendorProfiles
    : [];
  const hasLiveStorefront = linkedVendorProfiles.some((p) => p.isActive);
  // A leftover platform role on a NON-staff account: the thing that made a
  // vendor invisibly privileged. CONSUMER/CLIENT are the harmless defaults.
  const hasStrayRole =
    accountLoaded &&
    !isStaffAccount &&
    !!agent?.user_role &&
    !["CONSUMER", "CLIENT"].includes(agent.user_role);
  // You can convert TO staff always, and TO customer only when it is not one
  // already. You cannot convert TO vendor here: a storefront is made through
  // vendor onboarding, not by setting a flag.
  const convertTargets = [
    { value: "LUSUKU STAFF", label: "Lusuku staff account" },
    ...(agent?.userType !== "CLIENT"
      ? [{ value: "CLIENT", label: "Customer account" }]
      : []),
  ];

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // if (agent?._id) {
    dispatch(getUser(userId, user?.result?._id, user?.result.user_role));
    // }
  }, [userId]);

  useEffect(() => {
    if (agent?._id !== userId) return;
    setPostData((current) => ({
      ...current,
      user_role: agent?.user_role || "",
    }));
  }, [agent?._id, agent?.user_role, userId]);

  const clear = () => {
    setPostData({
      email: "",
      password: "",
      confirmPassword: "",
      user_role: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate the form inputs
    if (postData.password !== postData.confirmPassword) {
      toast.error("Password and Confirm Password do not match.");
      return;
    }
    if (postData.password && postData.password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    // Only send a password when the admin actually typed one — sending "" used
    // to overwrite the agent's stored hash and lock them out on next login.
    const payload = {
      newEmail: postData.email || agent?.email,
    };
    // A platform role is only meaningful on a staff account, and the server
    // now refuses the write for anything else. Do not even send it.
    if (staffControlsEnabled) {
      payload.role = postData.user_role || agent?.user_role;
    }
    if (postData.password) payload.newPassword = postData.password;
    // AWAIT the update, THEN navigate. (history.push used to be passed as a
    // second argument to dispatch — it navigated immediately, racing the
    // update against the staff-list fetch on the next page.)
    setSaving(true);
    try {
      await dispatch(profileUpdate(user?.result?._id, payload, agent?._id));
      // `permissionOverrides.length` matters: without it EVERY save on a
      // non-staff account fired this call and produced a red "Permission
      // overrides only apply to LUSUKU STAFF" toast beside the green success
      // one, even when nothing about access had been touched.
      if (canCustomizeAccess && accessReady && permissionOverrides.length) {
        await apiRbacReplacePermissionOverrides(
          userId,
          permissionOverrides,
          "Updated from the staff profile editor"
        );
      }
      history.push("/admin/users");
    } catch (error) {
      if (error?.config?.url?.includes("/api/rbac/")) {
        toast.error(
          error?.response?.data?.message ||
            "The profile was updated, but feature access could not be saved."
        );
      }
      // Re-read the account so the header stops showing pre-save values. The
      // update endpoint returns no document, and the reducer ignores a payload
      // without an `_id`, so without this the badge keeps rendering whatever
      // the account was when the page loaded — which is how the screen managed
      // to show "SUPERUSER" in the badge and "Admin" in the dropdown at once.
      dispatch(getUser(userId, user?.result?._id, user?.result?.user_role));
    } finally {
      setSaving(false);
    }
  };

  const handleChange = async (e) => {
    setPostData({ ...postData, [e.target.name]: e.target.value });
  };

  // Re-read the account so the screen reflects the new type/role immediately.
  const refreshAccount = () =>
    dispatch(getUser(userId, user?.result?._id, user?.result?.user_role));

  const handleClearRole = async () => {
    if (!actingSuperUser) return;
    setActing(true);
    try {
      const { data } = await apiClearPlatformRole(user?.result?._id, userId);
      toast.success(data?.message || "Platform role cleared.");
      refreshAccount();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Could not clear the role.");
    } finally {
      setActing(false);
    }
  };

  const handleConvert = async () => {
    if (!actingSuperUser || !convertType) return;
    if (!confirmName.trim()) {
      toast.error("Type the account's name or email to confirm.");
      return;
    }
    setActing(true);
    try {
      const payload = { toType: convertType, confirmName: confirmName.trim() };
      if (convertType === "LUSUKU STAFF") payload.user_role = convertRole;
      const { data } = await apiConvertAccountType(user?.result?._id, userId, payload);
      toast.success(data?.message || "Account type changed.");
      if (data?.inviteEmailSent === false && data?.inviteEmailIssue) {
        toast.warn(data.inviteEmailIssue, { autoClose: 9000 });
      }
      setConvertOpen(false);
      setConfirmName("");
      refreshAccount();
    } catch (err) {
      // A live storefront blocks the conversion; the server explains which one.
      toast.error(
        err?.response?.data?.message || "Could not change the account type.",
        { autoClose: 9000 }
      );
    } finally {
      setActing(false);
    }
  };

  // ── Helper: initials ─────────────────────────────────────────────────
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  return isLoading ? (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '60vh', flexDirection: 'column', gap: 16,
    }}>
      <Spinner
        animation="border"
        style={{ width: 44, height: 44, borderWidth: 3, color: COLORS.accent }}
      />
      <span style={{ fontSize: 13, color: COLORS.textSecondary, fontWeight: 500 }}>
        Loading profile…
      </span>
    </div>
  ) : (
    <>
      {/* you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " */}
      <Container fluid style={{ maxWidth: 1140, padding: '8px 20px 40px' }}>

        {/* ── Page Header ────────────────────────────────── */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <button
              onClick={() => history.goBack()}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: COLORS.textSecondary, fontSize: 18, padding: '4px 6px',
                borderRadius: 8, transition: TRANSITION, display: 'flex', alignItems: 'center',
              }}
              onMouseEnter={e => e.currentTarget.style.background = COLORS.accentLight}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}
              title="Go back"
            >
              ←
            </button>
            <h4 style={{
              margin: 0, fontSize: 22, fontWeight: 700, color: COLORS.textPrimary,
              letterSpacing: '-0.3px',
            }}>
              User Profile
            </h4>
          </div>
          <p style={{ margin: 0, fontSize: 13, color: COLORS.textMuted, paddingLeft: 40 }}>
            Manage user details, role assignment, and security settings
          </p>
        </div>

        <Row>
          {/* ═══════════════════════════════════════════════
              LEFT COLUMN — Edit Form + 2FA
              ═══════════════════════════════════════════════ */}
          <Col lg="8" md="7" className="mb-4">

            {/* ── Edit Role Card ──────────────────────────── */}
            <div className="ue-card-animated" style={{ ...cardStyle, marginBottom: 24 }}>
              <Form action="" className="form" method="" onSubmit={handleSubmit}>

                {/* Card Header */}
                <div style={{ padding: '22px 28px 16px', borderBottom: `1px solid ${COLORS.border}` }}>
                  <div style={sectionHeadStyle}>
                    <div style={{ ...sectionIconStyle, background: COLORS.accentLight, color: COLORS.accent }}>
                      <i className="nc-icon nc-settings-gear-64" />
                    </div>
                    <div>
                      <h5 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: COLORS.textPrimary }}>
                        Edit Profile
                      </h5>
                      <span style={{ fontSize: 12, color: COLORS.textMuted }}>
                        Update role and credentials
                      </span>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div style={{ padding: '24px 28px 28px' }}>

                  {/* ── Account Info Section ─────────────── */}
                  <div style={{ marginBottom: 24 }}>
                    <p style={{
                      fontSize: 11, fontWeight: 700, letterSpacing: '0.8px',
                      textTransform: 'uppercase', color: COLORS.textMuted, marginBottom: 14,
                    }}>
                      Account Information
                    </p>
                    <Row>
                      <Col md="4" className="mb-3">
                        <Form.Group style={{ margin: 0 }}>
                          <label className="ue-label">Created</label>
                          <Form.Control
                            className="ue-input"
                            defaultValue={moment(agent?.createdAt).utc().format("DD MMM YYYY")}
                            disabled
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4" className="mb-3">
                        <Form.Group style={{ margin: 0 }}>
                          <label className="ue-label">Full Name</label>
                          <Form.Control
                            className="ue-input"
                            defaultValue={agent?.name}
                            disabled
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4" className="mb-3">
                        <Form.Group style={{ margin: 0 }}>
                          <label className="ue-label">Email Address</label>
                          <Form.Control
                            className="ue-input"
                            defaultValue={agent?.email}
                            // Was `!user?.result?.user_role === "SUPERUSER"`,
                            // which negates the string first and then compares a
                            // boolean to "SUPERUSER" — always false, so the field
                            // was editable by anyone who reached this page.
                            disabled={user?.result?.user_role !== "SUPERUSER"}
                            autoComplete="off"
                            type="email"
                            name="email"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <div className="ue-divider" />

                  {/* ── What kind of account is this? ─────── */}
                  {/*
                    Shown when the account is NOT Lusuku staff. Everything below
                    it that only means something for staff is hidden, because
                    offering a platform role here and then having the server
                    refuse half the save is what produced a green "Profile
                    Updated" and a red "Permission overrides only apply to
                    LUSUKU STAFF" side by side on the same screen.
                  */}
                  {accountLoaded && !isStaffAccount && (
                    <div
                      style={{
                        background: "#fffbeb", border: "1px solid #fde68a",
                        borderRadius: 8, padding: "14px 16px", marginBottom: 24,
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: "#78350f", marginTop: 2 }} />
                        <div style={{ fontSize: 13, color: "#78350f", lineHeight: 1.6 }}>
                          <div style={{ fontWeight: 700, marginBottom: 4 }}>
                            This is a {accountKind}, not a Lusuku staff account
                          </div>
                          Platform roles and feature access apply only to Lusuku staff, so those controls are
                          hidden here.{" "}
                          {hasStrayRole ? (
                            <>
                              This account carries the role <strong>{agent.user_role}</strong>, which grants it
                              nothing now. Before the platform-staff rule, a leftover role like this counted as
                              real access that no staff list would ever show, which is the exact gap that was
                              closed. {actingSuperUser
                                ? "You can clear it below."
                                : "A Super User can clear it."}
                            </>
                          ) : null}
                        </div>
                      </div>

                      {/* ── Super-admin account controls ─────────────────────
                          Visibility and control the previous screen took away.
                          Super users only; the server enforces the same. */}
                      {actingSuperUser && (
                        <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #fde68a" }}>
                          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            {hasStrayRole && (
                              <Button
                                size="sm"
                                variant="warning"
                                type="button"
                                disabled={acting}
                                onClick={handleClearRole}
                                style={{ borderRadius: 6, fontWeight: 600 }}
                              >
                                {acting ? "Working…" : `Clear the ${agent.user_role} role`}
                              </Button>
                            )}
                            <Button
                              size="sm"
                              variant="outline-dark"
                              type="button"
                              disabled={acting}
                              onClick={() => {
                                setConvertOpen((v) => !v);
                                setConvertType(convertTargets[0]?.value || "");
                                setConfirmName("");
                              }}
                              style={{ borderRadius: 6, fontWeight: 600 }}
                            >
                              {convertOpen ? "Cancel change" : "Change account type"}
                            </Button>
                          </div>

                          {convertOpen && (
                            <div
                              style={{
                                marginTop: 14, background: "#ffffff",
                                border: "1px solid #e2e8f0", borderRadius: 8, padding: 14,
                              }}
                            >
                              {hasLiveStorefront && (
                                <div
                                  style={{
                                    fontSize: 12, color: "#7f1d1d", background: "#fef2f2",
                                    border: "1px solid #fecaca", borderRadius: 6,
                                    padding: "8px 10px", marginBottom: 12, lineHeight: 1.5,
                                  }}
                                >
                                  This account still owns a live storefront (see the card on the right).
                                  Converting it would leave that storefront without an owner, so deactivate it
                                  from its management page first, then come back here.
                                </div>
                              )}
                              <label className="ue-label">Convert this account to</label>
                              <div className="ue-select" style={{ marginBottom: 12 }}>
                                <Select
                                  classNamePrefix="react-select"
                                  value={convertTargets.find((t) => t.value === convertType) || null}
                                  onChange={(opt) => setConvertType(opt ? opt.value : "")}
                                  options={convertTargets}
                                  placeholder="Choose a type"
                                  isDisabled={hasLiveStorefront}
                                />
                              </div>

                              {convertType === "LUSUKU STAFF" && (
                                <>
                                  <label className="ue-label">Staff role to grant</label>
                                  <div className="ue-select" style={{ marginBottom: 12 }}>
                                    <Select
                                      classNamePrefix="react-select"
                                      value={{ value: convertRole, label:
                                        convertRole === "SUPERUSER" ? "Super User"
                                          : convertRole.charAt(0) + convertRole.slice(1).toLowerCase() }}
                                      onChange={(opt) => setConvertRole(opt.value)}
                                      options={[
                                        { value: "CONSUMER", label: "Consumer" },
                                        { value: "CREATOR", label: "Creator" },
                                        { value: "SUPERVISOR", label: "Supervisor" },
                                        { value: "ADMIN", label: "Admin" },
                                        { value: "SUPERUSER", label: "Super User" },
                                      ]}
                                      isDisabled={hasLiveStorefront}
                                    />
                                  </div>
                                  <p style={{ fontSize: 11, color: COLORS.textMuted, marginTop: -6, marginBottom: 12 }}>
                                    ADMIN and Super User need a company email on the account, and the person sets
                                    their own staff password from an emailed link.
                                  </p>
                                </>
                              )}

                              <label className="ue-label">
                                Type <strong>{agent?.name || agent?.email}</strong> to confirm
                              </label>
                              <Form.Control
                                className="ue-input"
                                placeholder={agent?.name || agent?.email}
                                value={confirmName}
                                disabled={hasLiveStorefront}
                                onChange={(e) => setConfirmName(e.target.value)}
                                style={{ marginBottom: 12 }}
                              />
                              <Button
                                size="sm"
                                variant="dark"
                                type="button"
                                disabled={acting || hasLiveStorefront || !convertType || !confirmName.trim()}
                                onClick={handleConvert}
                                style={{ borderRadius: 6, fontWeight: 600 }}
                              >
                                {acting ? "Converting…" : "Convert account"}
                              </Button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* ── Password Section ──────────────────── */}
                  <div style={{ marginBottom: 24 }}>
                    <p style={{
                      fontSize: 11, fontWeight: 700, letterSpacing: '0.8px',
                      textTransform: 'uppercase', color: COLORS.textMuted, marginBottom: 14,
                    }}>
                      Password Reset
                    </p>
                    <p style={{ fontSize: 12, color: COLORS.textMuted, marginTop: -8, marginBottom: 12 }}>
                      Setting a password here emails the account holder a security notice naming you and the
                      time. The password itself is never emailed — if they should choose their own, use
                      <strong> Email Reset Link</strong> on the Access Control page instead.
                    </p>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Form.Group style={{ margin: 0 }}>
                          <label className="ue-label">New Password</label>
                          <Form.Control
                            className="ue-input"
                            placeholder="Enter new password"
                            type="password"
                            name="password"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6" className="mb-3">
                        <Form.Group style={{ margin: 0 }}>
                          <label className="ue-label">Confirm Password</label>
                          <Form.Control
                            className="ue-input"
                            placeholder="Re-enter password"
                            type="password"
                            name="confirmPassword"
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {staffControlsEnabled && <div className="ue-divider" />}

                  {/* ── Role Assignment Section (staff only) ── */}
                  {staffControlsEnabled && (
                  <div style={{ marginBottom: 28 }}>
                    <p style={{
                      fontSize: 11, fontWeight: 700, letterSpacing: '0.8px',
                      textTransform: 'uppercase', color: COLORS.textMuted, marginBottom: 14,
                    }}>
                      Role Assignment <span style={{ color: COLORS.danger }}>*</span>
                    </p>
                    <div className="ue-select">
                      <Select
                        classNamePrefix="react-select"
                        name="user_role"
                        value={{
                          value: postData.user_role || agent?.user_role,
                          label:
                            (postData.user_role || agent?.user_role) === "SUPERUSER"
                              ? "Super User"
                              : (postData.user_role || agent?.user_role || "")
                                  .toLowerCase()
                                  .replace(/^\w/, (letter) => letter.toUpperCase()),
                        }}
                        onChange={(value) => {
                          setPostData({
                            ...postData,
                            user_role: value.value,
                          });
                          setPermissionOverrides([]);
                        }}
                        options={[
                          { value: "SUPERUSER", label: "Super User" },
                          { value: "ADMIN", label: "Admin" },
                          { value: "SUPERVISOR", label: "Supervisor" },
                          { value: "CREATOR", label: "Creator" },
                          { value: "CONSUMER", label: "Consumer" },
                        ]}
                        placeholder="Select Role"
                      />
                    </div>
                  </div>
                  )}

                  {staffControlsEnabled && (
                    <StaffFeatureAccessEditor
                      role={postData.user_role || agent?.user_role}
                      userId={userId}
                      canCustomize={canCustomizeAccess}
                      onChange={handleAccessChange}
                      onReadyChange={setAccessReady}
                    />
                  )}

                  {/* ── Submit Button ────────────────────── */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
                    <Button
                      className="ue-btn-primary"
                      type="submit"
                      disabled={!canCustomizeAccess || saving}
                    >
                      {saving ? (
                        <>
                          <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />
                          Saving...
                        </>
                      ) : (
                        <>
                          <i className="nc-icon nc-check-2" style={{ marginRight: 8 }} />
                          Save Changes
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </Form>
            </div>

            {/* ── 2FA Management Card (own privileged account only) ────── */}
            {isSelfEdit && isStaffAccount && STAFF_2FA_ROLES.includes(agent?.user_role) && (
              <div id="two-factor-authentication" className="ue-card-animated" style={cardStyle}>

                {/* Card Header */}
                <div style={{ padding: '22px 28px 16px', borderBottom: `1px solid ${COLORS.border}` }}>
                  <div style={sectionHeadStyle}>
                    <div style={{
                      ...sectionIconStyle,
                      background: twoFAEnabled ? COLORS.successLight : COLORS.dangerLight,
                      color: twoFAEnabled ? COLORS.success : COLORS.danger,
                    }}>
                      <i className="nc-icon nc-lock-circle-open" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <h5 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: COLORS.textPrimary }}>
                          Two-Factor Authentication
                        </h5>
                        {twoFAEnabled && (
                          <span className="ue-2fa-chip" style={{
                            background: COLORS.successLight,
                            color: COLORS.success,
                          }}>
                            <span style={{ width: 6, height: 6, borderRadius: '50%', background: COLORS.success, display: 'inline-block' }} />
                            Active
                          </span>
                        )}
                      </div>
                      <span style={{ fontSize: 12, color: COLORS.textMuted }}>
                        Secure your account with TOTP authentication
                      </span>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div style={{ padding: '24px 28px 28px' }}>
                  {twoFAStep === 'idle' && !twoFAEnabled && (
                    <>
                      <div style={{
                        background: COLORS.accentLight, borderRadius: 12,
                        padding: '16px 20px', marginBottom: 20,
                        display: 'flex', alignItems: 'flex-start', gap: 12,
                      }}>
                        <i className="nc-icon nc-circle-09" style={{ fontSize: 20, color: COLORS.accent, flexShrink: 0, marginTop: 1 }} />
                        <p style={{ fontSize: 13, color: COLORS.textSecondary, margin: 0, lineHeight: 1.6 }}>
                          Add an extra layer of security to your account. You'll need <strong>Google Authenticator</strong> or any TOTP-compatible app to generate verification codes.
                        </p>
                      </div>
                      <Button
                        className="ue-btn-primary"
                        onClick={handle2FASetup}
                        disabled={twoFALoading}
                        style={{ boxShadow: `0 4px 14px ${COLORS.successLight}`, background: `${COLORS.success} !important` }}
                      >
                        {twoFALoading ? <Spinner animation="border" size="sm" /> : (
                          <>
                            <i className="nc-icon nc-key-25" style={{ marginRight: 8 }} />
                            Enable 2FA
                          </>
                        )}
                      </Button>
                    </>
                  )}

                  {twoFAStep === 'setup' && (
                    <>
                      <p style={{ fontSize: 13, color: COLORS.textSecondary, marginBottom: 16, lineHeight: 1.6 }}>
                        Scan this QR code with <strong>Google Authenticator</strong>, then enter the 6-digit code below to verify.
                      </p>
                      {qrDataUrl && (
                        <div style={{
                          display: 'flex', justifyContent: 'center', marginBottom: 16,
                          padding: 16, background: '#fff', borderRadius: 12,
                          border: `1px solid ${COLORS.border}`, width: 'fit-content',
                          margin: '0 auto 16px',
                        }}>
                          <img src={qrDataUrl} alt="2FA QR" style={{ width: 160, display: 'block' }} />
                        </div>
                      )}
                      <p style={{
                        fontSize: 11, color: COLORS.textMuted, wordBreak: 'break-all',
                        marginBottom: 16, textAlign: 'center',
                      }}>
                        Manual key:&nbsp;
                        <code style={{
                          background: COLORS.accentLight, padding: '2px 8px',
                          borderRadius: 4, fontWeight: 600, color: COLORS.accent,
                        }}>
                          {twoFASecret}
                        </code>
                      </p>
                      <div style={{ maxWidth: 260, margin: '0 auto' }}>
                        <Form.Control
                          className="ue-input"
                          type="text"
                          placeholder="Enter 6-digit code"
                          value={twoFATotpInput}
                          onChange={e => setTwoFATotpInput(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          style={{ textAlign: 'center', fontWeight: 600, letterSpacing: 6, fontSize: 18, marginBottom: 12 }}
                          inputMode="numeric"
                        />
                      </div>
                      {twoFAError && (
                        <p style={{
                          color: COLORS.danger, fontSize: 13, marginBottom: 8,
                          textAlign: 'center', fontWeight: 500,
                        }}>
                          {twoFAError}
                        </p>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 8 }}>
                        <Button
                          className="ue-btn-primary"
                          onClick={handle2FAConfirm}
                          disabled={twoFALoading || twoFATotpInput.length !== 6}
                        >
                          {twoFALoading ? <Spinner animation="border" size="sm" /> : 'Activate 2FA'}
                        </Button>
                        <Button
                          variant="light"
                          size="sm"
                          style={{
                            borderRadius: RADIUS.button, fontSize: 13, fontWeight: 500,
                            padding: '8px 18px', border: `1px solid ${COLORS.border}`,
                          }}
                          onClick={() => { setTwoFAStep('idle'); setTwoFAError(''); }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </>
                  )}

                  {twoFAStep === 'done' && (
                    <>
                      <div style={{
                        background: COLORS.successLight, borderRadius: 12,
                        padding: '14px 18px', marginBottom: 16,
                        display: 'flex', alignItems: 'center', gap: 10,
                      }}>
                        <i className="nc-icon nc-check-2" style={{ fontSize: 16, color: COLORS.success, flexShrink: 0 }} />
                        <p style={{ color: COLORS.success, fontWeight: 600, margin: 0, fontSize: 14 }}>
                          Two-factor authentication is now active.
                        </p>
                      </div>
                      <p style={{ fontSize: 13, color: COLORS.textSecondary, marginBottom: 12, lineHeight: 1.6 }}>
                        Save these backup codes in a safe place. Each can only be used <strong>once</strong>.
                      </p>
                      <div className="ue-backup-grid" style={{ marginBottom: 16 }}>
                        {backupCodes.map((c, i) => (
                          <div key={i} className="ue-backup-code">{c}</div>
                        ))}
                      </div>
                      <Button
                        variant="light"
                        size="sm"
                        style={{
                          borderRadius: RADIUS.button, fontSize: 13, fontWeight: 600,
                          border: `1px solid ${COLORS.border}`, padding: '8px 22px',
                        }}
                        onClick={() => setTwoFAStep('idle')}
                      >
                        Done
                      </Button>
                    </>
                  )}

                  {twoFAStep === 'idle' && twoFAEnabled && (
                    <>
                      <p style={{ fontSize: 13, color: COLORS.textSecondary, marginBottom: 16, lineHeight: 1.6 }}>
                        Two-factor authentication is currently active. To disable it, enter your current authenticator code below.
                      </p>
                      <div style={{ maxWidth: 260 }}>
                        <Form.Control
                          className="ue-input"
                          type="text"
                          placeholder="6-digit code"
                          value={twoFATotpInput}
                          onChange={e => setTwoFATotpInput(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          style={{ textAlign: 'center', fontWeight: 600, letterSpacing: 6, fontSize: 18, marginBottom: 12 }}
                          inputMode="numeric"
                        />
                      </div>
                      {twoFAError && (
                        <p style={{ color: COLORS.danger, fontSize: 13, marginBottom: 8, fontWeight: 500 }}>
                          {twoFAError}
                        </p>
                      )}
                      <Button
                        variant="danger"
                        size="sm"
                        style={{
                          borderRadius: RADIUS.button, fontSize: 13, fontWeight: 600,
                          padding: '8px 22px', background: COLORS.danger,
                          border: 'none', boxShadow: '0 4px 14px rgba(239,68,68,0.25)',
                        }}
                        onClick={handle2FADisable}
                        disabled={twoFALoading || twoFATotpInput.length !== 6}
                      >
                        {twoFALoading ? <Spinner animation="border" size="sm" /> : 'Disable 2FA'}
                      </Button>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* ── 2FA read-only (privileged staff viewed by another admin) ───── */}
            {!isSelfEdit && isStaffAccount && STAFF_2FA_ROLES.includes(agent?.user_role) && (
              <div id="two-factor-authentication" className="ue-card-animated" style={{ ...cardStyle, marginTop: 24 }}>
                <div style={{ padding: '22px 28px 16px', borderBottom: `1px solid ${COLORS.border}` }}>
                  <div style={sectionHeadStyle}>
                    <div style={{
                      ...sectionIconStyle,
                      background: agent?.twoFA?.enabled ? COLORS.successLight : COLORS.dangerLight,
                      color: agent?.twoFA?.enabled ? COLORS.success : COLORS.danger,
                    }}>
                      <i className="nc-icon nc-lock-circle-open" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                        <h5 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: COLORS.textPrimary }}>
                          Two-Factor Authentication
                        </h5>
                        {agent?.twoFA?.enabled ? (
                          <span className="ue-2fa-chip" style={{ background: COLORS.successLight, color: COLORS.success }}>
                            <span style={{ width: 6, height: 6, borderRadius: '50%', background: COLORS.success, display: 'inline-block' }} />
                            Active
                          </span>
                        ) : (
                          <span className="ue-2fa-chip" style={{ background: COLORS.dangerLight, color: COLORS.danger }}>
                            Off
                          </span>
                        )}
                      </div>
                      <span style={{ fontSize: 12, color: COLORS.textMuted }}>
                        Status for this account (read-only)
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ padding: '24px 28px 28px' }}>
                  <p style={{ fontSize: 13, color: COLORS.textSecondary, margin: 0, lineHeight: 1.65 }}>
                    Only <strong>{agent?.name || 'this user'}</strong> can turn 2FA on or off, using{' '}
                    <strong>Google Authenticator</strong> (or another TOTP app), after they sign in to this dashboard
                    as themselves and open this same section on their profile.
                  </p>
                </div>
              </div>
            )}
          </Col>

          {/* ═══════════════════════════════════════════════
              RIGHT COLUMN — Profile Card
              ═══════════════════════════════════════════════ */}
          <Col lg="4" md="5" className="mb-4">
            <div className="ue-card-animated ue-profile-card" style={{ ...cardStyle, position: 'sticky', top: 90 }}>

              {/* Banner */}
              <div style={{
                height: 110,
                background: COLORS.profileBanner,
                position: 'relative',
                overflow: 'hidden',
              }} />

              {/* Avatar */}
              <div style={{
                display: 'flex', justifyContent: 'center',
                marginTop: -52, position: 'relative', zIndex: 2,
              }}>
                <div style={{ position: 'relative', width: 96, height: 96 }}>
                  <div className="ue-avatar-ring" />
                  <Avatar
                    style={{
                      width: 88, height: 88,
                      position: 'absolute', top: 4, left: 4,
                      fontSize: 32, fontWeight: 700,
                      background: COLORS.avatarBg,
                      color: '#fff',
                      border: '3px solid #fff',
                      zIndex: 1,
                    }}
                    alt={agent?.email}
                    src={""}
                  >
                    {getInitials(agent?.name)}
                  </Avatar>
                </div>
              </div>

              {/* Profile Info */}
              <div style={{ textAlign: 'center', padding: '16px 24px 8px' }}>
                <h5 style={{
                  margin: '0 0 6px', fontSize: 18, fontWeight: 700,
                  color: COLORS.textPrimary, textTransform: 'capitalize',
                }}>
                  {agent?.name}
                </h5>
                {/*
                  The badge used to render `agent.user_role` unqualified, so a
                  vendor row holding SUPERUSER was presented as a super user in
                  the same gold chip a real one gets. A role only reads as
                  platform authority on a staff account; anywhere else the
                  account TYPE is the honest headline.
                */}
                {isStaffAccount ? (
                  <span className="ue-role-badge" style={getRoleBadgeStyle(agent?.user_role)}>
                    {agent?.user_role}
                  </span>
                ) : (
                  <span
                    className="ue-role-badge"
                    style={{ background: "#f1f5f9", color: "#475569", border: "1px solid #e2e8f0" }}
                    title={
                      agent?.user_role
                        ? `Carries the role ${agent.user_role}, which does not apply to this account type`
                        : undefined
                    }
                  >
                    {accountLoaded ? accountKind.toUpperCase() : "…"}
                  </span>
                )}
              </div>

              <div className="ue-divider" style={{ margin: '16px 24px' }} />

              {/* Details */}
              <div style={{ padding: '0 24px 24px' }}>
                {/* Email */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                  <div style={{
                    width: 34, height: 34, borderRadius: 8,
                    background: COLORS.accentLight, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: COLORS.accent, fontSize: 14, flexShrink: 0,
                  }}>
                    <i className="nc-icon nc-email-83" />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <span style={{ fontSize: 11, color: COLORS.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Email
                    </span>
                    <p style={{
                      margin: 0, fontSize: 13, color: COLORS.textPrimary, fontWeight: 500,
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                      {agent?.email}
                    </p>
                  </div>
                </div>

                {/* Member Since */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                  <div style={{
                    width: 34, height: 34, borderRadius: 8,
                    background: COLORS.successLight, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: COLORS.success, fontSize: 14, flexShrink: 0,
                  }}>
                    <i className="nc-icon nc-time-alarm" />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <span style={{ fontSize: 11, color: COLORS.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Member Since
                    </span>
                    <p style={{ margin: 0, fontSize: 13, color: COLORS.textPrimary, fontWeight: 500 }}>
                      {moment(agent?.createdAt).format("MMMM YYYY")}
                    </p>
                  </div>
                </div>

                {/* User ID */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 34, height: 34, borderRadius: 8,
                    background: COLORS.accentLight, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: COLORS.accent, fontSize: 14, flexShrink: 0,
                  }}>
                    <i className="nc-icon nc-badge" />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <span style={{ fontSize: 11, color: COLORS.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      User ID
                    </span>
                    <p style={{
                      margin: 0, fontSize: 12, color: COLORS.accent, fontWeight: 600,
                      fontFamily: "'SFMono-Regular', monospace",
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                      {agent?._id}
                    </p>
                  </div>
                </div>

                {/* ── Linked vendor storefront(s) ────────────────────────────
                    Answers "which vendor is this login?". A staff or customer
                    account shows nothing here; a vendor names its storefront(s)
                    with a link to the page that manages them. */}
                {accountLoaded && linkedVendorProfiles.length > 0 && (
                  <div style={{ marginTop: 18, paddingTop: 16, borderTop: `1px solid ${COLORS.border}` }}>
                    <span style={{ fontSize: 11, color: COLORS.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      {linkedVendorProfiles.length > 1 ? "Linked storefronts" : "Linked storefront"}
                    </span>
                    {linkedVendorProfiles.map((p) => (
                      <div
                        key={p.id}
                        style={{
                          display: "flex", alignItems: "center", gap: 10, marginTop: 10,
                        }}
                      >
                        <div style={{
                          width: 34, height: 34, borderRadius: 8,
                          background: COLORS.accentLight, display: "flex",
                          alignItems: "center", justifyContent: "center",
                          color: COLORS.accent, fontSize: 14, flexShrink: 0,
                        }}>
                          <i className="nc-icon nc-shop" />
                        </div>
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <p style={{
                            margin: 0, fontSize: 13, color: COLORS.textPrimary, fontWeight: 600,
                            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                          }}>
                            {p.name}
                          </p>
                          <span style={{ fontSize: 11, color: COLORS.textSecondary }}>
                            {p.label}
                            {"  "}
                            <span style={{
                              display: "inline-block", marginLeft: 4, padding: "1px 7px",
                              borderRadius: 999, fontSize: 10, fontWeight: 700,
                              background: p.isActive ? COLORS.successLight : "#f1f5f9",
                              color: p.isActive ? "#047857" : "#64748b",
                            }}>
                              {p.isActive ? "Active" : "Inactive"}
                            </span>
                          </span>
                        </div>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          type="button"
                          onClick={() => history.push(p.managePath)}
                          style={{ borderRadius: 6, fontWeight: 600, fontSize: 11, padding: "3px 10px", whiteSpace: "nowrap" }}
                        >
                          Open
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserEdit;
